<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de classificação de risco`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/pronto-atendimento/classificacao-risco/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'pronto-atendimento-classificacao-risco-index' })
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>